export default "__VITE_ASSET__CoWIJbmy__"